export var OrangeKitWalletId;
(function (OrangeKitWalletId) {
    OrangeKitWalletId["OKX"] = "orangekit-okx";
    OrangeKitWalletId["UNISAT"] = "orangekit-unisat";
    OrangeKitWalletId["XVERSE"] = "orangekit-xverse";
})(OrangeKitWalletId || (OrangeKitWalletId = {}));
//# sourceMappingURL=types.js.map